/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // FUNCTION FOR SCROLLING ONE PAGE MENU
  // jQuery('#main_menu li a').on('click', function () {
  //   var the_id = jQuery(this).attr("href");
  //   jQuery('html, body').animate({
  //       scrollTop: jQuery(the_id).offset().top - 80
  //   }, 'slow');
  //   jQuery(".navbar-collapse").collapse('hide');
  //   jQuery('#main_menu li a').removeClass("active");
  //   jQuery(this).addClass("active");
  //   return false;
  // });

  jQuery(function ($) {
    //Create the cookie object
    var cookieStorage = {
      setCookie: function setCookie(key, value, time, path) {
        var expires = new Date();
        expires.setTime(expires.getTime() + time);
        var pathValue = "";
        if (typeof path !== "undefined") {
          pathValue = "path=" + path + ";";
        }
        document.cookie =
          key +
          "=" +
          value +
          ";" +
          pathValue +
          "expires=" +
          expires.toUTCString();
      },
      getCookie: function getCookie(key) {
        var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
        return keyValue ? keyValue[2] : null;
      },
      removeCookie: function removeCookie(key) {
        document.cookie = key + "=; Max-Age=0; path=/";
      },
    };

    //Click on dark mode icon. Add dark mode classes and wrappers. Store user preference through sessions
    $(".switch").click(function () {
      //Show either moon or sun
      $(".switch").toggleClass("active");
      //If dark mode is selected
      if ($(".switch").hasClass("active")) {
        //Add dark mode class to the body
        $("body").addClass("dark-mode");
        cookieStorage.setCookie("yonkovNightMode", "true", 2628000000, "/");
      } else {
        $("body").removeClass("dark-mode");
        setTimeout(function () {
          cookieStorage.removeCookie("yonkovNightMode");
        }, 100);
      }
    });
    //Check Storage. Display user preference
    if (cookieStorage.getCookie("yonkovNightMode")) {
      $("body").addClass("dark-mode");
      $(".switch").addClass("active");
    }

    jQuery(".quick-comment .carousel-wrapper").slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 400,
      autoplay: true,
      fade: true,
      autoplaySpeed: 24000,
      prevArrow:
        "<button type='button' class='slick-prev' data-role='none' role='button' aria-label='Previous' tabindex='0'></button>",
      nextArrow:
        "<button type='button' class='slick-next' data-role='none' role='button' aria-label='Next' tabindex='0'></button>",
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    jQuery(".quick-comment-mobile .card-header").on("click", function () {
      jQuery(".quick-comment-mobile .carousel")
        .slick("unslick")
        .slick("reinit")
        .slick({
          dots: false,
          arrows: true,
          centerMode: true,
          infinite: true,
          speed: 400,
          autoplay: true,
          fade: true,
          autoplaySpeed: 5000,
          prevArrow:
            "<button type='button' class='slick-prev' data-role='none' role='button' aria-label='Previous' tabindex='0'></button>",
          nextArrow:
            "<button type='button' class='slick-next' data-role='none' role='button' aria-label='Next' tabindex='0'></button>",
          slidesToShow: 1,
          slidesToScroll: 1,
        });
    });

    jQuery(".quick-comment-mobile .carousel").slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 400,
      autoplay: true,
      centerMode: true,
      fade: true,
      autoplaySpeed: 5000,
      prevArrow:
        "<button type='button' class='slick-prev' data-role='none' role='button' aria-label='Previous' tabindex='0'></button>",
      nextArrow:
        "<button type='button' class='slick-next' data-role='none' role='button' aria-label='Next' tabindex='0'></button>",
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    //MOBILE MENU TOGGLER
    var body = $("body");
    var settingsToggler = $(".settings-toggler");
    var settingsSupportedContent = $(".settings-menu");
    var navbarSupportedContent = $("#navbarSupportedContent");
    var burgerMenu = $(".navbar-toggler");
    $.support.transition = false;
    $(".menu").click(function () {
      $(this).toggleClass("open");
    });

    $(settingsToggler).click(function () {
      $(this).toggleClass("open");
    });

    burgerMenu.on("click", function (e) {
      e.preventDefault();
      body.removeClass("overflow-y-hidden-settings");
      $(settingsToggler).removeClass("open");
      body.toggleClass("overflow-y-hidden-menu");
      $(".wrap").removeClass("hide-opacity-settings");
      $(".wrap").toggleClass("hide-opacity-menu");
      settingsSupportedContent.collapse("hide");
      navbarSupportedContent.collapse("show");
      settingsSupportedContent.removeClass("settings-opened");
    });

    settingsToggler.on("click", function (e) {
      e.preventDefault();
      body.removeClass("overflow-y-hidden-menu");
      $(".menu").removeClass("open");
      body.toggleClass("overflow-y-hidden-settings");
      $(".wrap").removeClass("hide-opacity-menu");
      $(".wrap").toggleClass("hide-opacity-settings");
      navbarSupportedContent.collapse("hide");
      settingsSupportedContent.collapse("show");

      settingsSupportedContent.toggleClass("settings-opened");
    });

    //HEADER MOBILE
    $(window).on("load scroll resize", stickyHeader);
    //stickyHeader();

    function stickyHeader() {
      var header = $(".header");
      var bar = $(".announcement-bar");
      var barHeight = $(".announcement-bar").outerHeight();
      var headerHeight = header.outerHeight();

      var topWrapperHeader = $(".top-wrapper-header");
      var topWrapperHeaderHeight = topWrapperHeader.outerHeight();

      if (window.innerWidth < 768) {
        //header.css("top", barHeight);
        $(body).css("padding-top", topWrapperHeaderHeight);

        if ($(window).scrollTop() > barHeight) {
          $(body).css("padding-top", topWrapperHeaderHeight);
          //$(bar).css("opacity", "0");
          $(".top-wrapper-header").css("top", "-" + barHeight + "px");
          //$(header).css("top", "0");
          $(".bv-logo-mobile").show();
          $(".mg-mobile-logo").hide();
          $(".menu-collapse, .settings-menu").css("top", headerHeight);
        } else {
          $(body).css("padding-top", topWrapperHeaderHeight);
          //$(bar).css("opacity", "1");
          $(".top-wrapper-header").css("top", "0");
          $(".bv-logo-mobile").hide();
          $(".mg-mobile-logo").show();
          $(".menu-collapse, .settings-menu").css(
            "top",
            headerHeight + barHeight
          );
        }
      }

      if (window.innerWidth > 767) {
        $(body).css("padding-top", "0");
      }
    }

    //language switcher desktop
    var languageSwitcher = jQuery(".language-switcher");
    languageSwitcher.on("click", "a", function (el) {
      var clickedElement = jQuery(el.currentTarget);

      var updateText = clickedElement.text();

      var updateElement = jQuery(el.currentTarget)
        .closest(".language-switcher")
        .find(".dropdown-toggle span");
      updateElement.text(updateText);
      updateElement.val(updateText);
    });

    $(".language-switcher a").click(function () {
      $(".language-switcher a").removeClass("active");
      $(this).addClass("active");
    });

    $(document).on(
      "click",
      ".settings-wrapper .dropdown-menu, .language-switcher .dropdown-menu",
      function (e) {
        e.stopPropagation();
      }
    );

    if (!$.cookie("sticky-signup-closed")) {
      $("#sticky-signup").css("position", "fixed");
      $("#sticky-signup .cancel, #myForm .cancel").on("click", function () {
        closeBanner();
        closeForm();
        $.cookie("sticky-signup-closed", "1", { expires: 1, path: "/" });
      });
    } else {
      closeBanner();
      closeForm();
      document.getElementById("#sticky-signup").style.display = "none";
    }

    jQuery(document).ready(function() {
      add_target_blank_to_external_links();
    });

    function add_target_blank_to_external_links() {
      $('body a[href^="http"]').not('a[href*="' + location.hostname + '"]').attr({target: "_blank", rel: "noopener"});
    }
  });
})(jQuery); // Fully reference jQuery after this point.

// Newsletter Popup
function openForm() {
  document.getElementById("myForm").style.display = "block";
  document.getElementById("sticky-signup").style.display = "none";
}
function openBanner() {
  document.getElementById("myForm").style.display = "block";
}
function closeBanner() {
  document.getElementById("sticky-signup").style.display = "none";
  document.getElementById("signup-small").style.display = "inline";
}
function closeForm() {
  document.getElementById("myForm").style.display = "none";
  document.getElementById("sticky-signup").style.display = "none";
  document.getElementById("signup-small").style.display = "inline";
}

function newsletterCookie() {
  const urlParams = new URLSearchParams(window.location.search);
  if (document.cookie.includes("fromNewsletter=true")) {
    document.body.setAttribute("data-from-newsletter", "true");
  }
  if (urlParams.get('source') === 'email-newsletter') {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}
newsletterCookie();

  // window.addEventListener('load', function() {
  //       var selector = Math.random() < .5 ? ".advert-wrapper-a" : ".advert-wrapper-b";
  //       document.querySelector(selector).classList.add('c');
  //     });


  document.addEventListener("DOMContentLoaded", function() {
    // Select the element you want to delay displaying
    const delayedElement = document.getElementById("sticky-signup");

     // Delay showing the element for 5 seconds (5000 milliseconds)
  setTimeout(function() {
    // Add a CSS class to trigger the slide-in animation
    delayedElement.classList.add("showsignup");
  }, 5000); // 5000 milliseconds (5 seconds)
  });